import { ChartService } from '../services/chart.service';

/** Fila del embudo de entregabilidad (Estatus | Total | %). */
export interface IFunnelRow {
  estatus: string;
  total: number;
  /** El original mezcla formatos: "100%", "90.72", "9.28%"… se respeta tal cual. */
  porcentaje: string;
}

/** Serie de un canal de envío en la gráfica de columnas agrupadas. */
export interface IChannelSeries {
  name: string;
  color: string;
  data: Array<number>;
}

/* -------------------------------------------------------------------------- */
/*                      ANCHOR embudo de entregabilidad                       */
/* -------------------------------------------------------------------------- */

/**
 * Las cifras cierran entre sí: higienizados + disponibles = recibidos, y
 * rebotados + sin abrir + abiertos = disponibles. Abandonados y efectivos
 * reparten los abiertos.
 */
export const EMBUDO_ENTREGABILIDAD: Array<IFunnelRow> = [
  { estatus: 'Registros recibidos',                   total: 1287416,  porcentaje: '100%' },
  { estatus: 'Registros higienizados & cuarentenas',  total: 1167944,  porcentaje: '90.72' },
  { estatus: 'Disponibles para envío',                total: 119472,   porcentaje: '9.28%' },
  { estatus: 'Rebotados',                             total: 1804,     porcentaje: '1.51%' },
  { estatus: 'Sin abrir',                             total: 94813,    porcentaje: '79.36%' },
  { estatus: 'Abiertos',                              total: 22855,    porcentaje: '19.13%' },
  { estatus: 'Abandonados',                           total: 14265,    porcentaje: '11.94%' },
  { estatus: 'Efectivos',                             total: 8590,     porcentaje: '7.19%' },
];

/* -------------------------------------------------------------------------- */
/*                       ANCHOR envíos por día y canal                        */
/* -------------------------------------------------------------------------- */

/**
 * Catorce días consecutivos que terminan en el corte del tablero (11/08/2026);
 * el salto de línea es el segundo renglón del eje X. Los domingos no se envía
 * y el sábado se envía a media máquina: por eso los ceros y los valles.
 */
export const DIAS_ENVIO: Array<string> = [
  'Miércoles\n2026-07-29',
  'Jueves\n2026-07-30',
  'Viernes\n2026-07-31',
  'Sábado\n2026-08-01',
  'Domingo\n2026-08-02',
  'Lunes\n2026-08-03',
  'Martes\n2026-08-04',
  'Miércoles\n2026-08-05',
  'Jueves\n2026-08-06',
  'Viernes\n2026-08-07',
  'Sábado\n2026-08-08',
  'Domingo\n2026-08-09',
  'Lunes\n2026-08-10',
  'Martes\n2026-08-11',
];

export const ENVIOS_POR_CANAL: Array<IChannelSeries> = [
  {
    name: 'SMS',
    color: ChartService.COLORS.teal,
    data: [21, 26, 29, 12, 0, 23, 21, 23, 25, 23, 8, 0, 23, 23],
  },
  {
    name: 'Mail',
    color: ChartService.COLORS.blue,
    data: [11, 14, 15, 6, 0, 12, 11, 12, 13, 12, 4, 0, 12, 12],
  },
  {
    name: 'WA',
    color: ChartService.COLORS.magenta,
    data: [247, 310, 344, 140, 0, 276, 242, 273, 297, 265, 90, 0, 265, 269],
  },
];
